












import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import RussiaResortRegionPreviewMap from '@/russiaResort/RussiaResortRegionPreviewMap.vue';
import { IRussiaResortRegion } from '../plugins/store.russiaResort';

@Component({
	components: {
		RussiaResortRegionPreviewMap,
	},
})
export default class RussiaResort extends Vue {

	public get regions(): IRussiaResortRegion[] {
		return this.$store.getters['russiaResort/getRegions'].filter((v) => v.code !== -1);
	}
}
